import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BodySchemaZoneValue } from '@bepatient/body-schema-store';

@Component({
  selector: 'bepatient-body-schema-pain-popup',
  templateUrl: './body-schema-pain-popup.component.html',
  styleUrls: ['./body-schema-pain-popup.component.scss'],
  standalone: false
})
export class BodySchemaPainPopupComponent {
  @Input() color: string;
  @Input() selectedValue: BodySchemaZoneValue;
  @Input() useSurfacePain: boolean;

  @Input() title: string;
  @Input() deepPainLabel: string;
  @Input() surfacePainLabel: string;

  @Output() setValue = new EventEmitter<BodySchemaZoneValue>();

  deepPain: BodySchemaZoneValue[] = [
    { type: 1, weight: 0 },
    { type: 1, weight: 1 },
    { type: 1, weight: 2 },
    { type: 1, weight: 3 },
    { type: 1, weight: 4 }
  ];

  surfacePain: BodySchemaZoneValue[] = [
    { type: 0, weight: 0 },
    { type: 0, weight: 1 },
    { type: 0, weight: 2 },
    { type: 0, weight: 3 },
    { type: 0, weight: 4 }
  ];

  get svgFill(): string {
    return (
      `url(` +
      location.protocol +
      `//` +
      location.host +
      location.pathname +
      `#gradient`
    );
  }

  border(v: BodySchemaZoneValue): string {
    return this.selectedValue &&
      this.selectedValue.type === v.type &&
      this.selectedValue.weight === v.weight
      ? '#2e2e2e'
      : '#fff';
  }
}
